// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as ContentSection from "common/src/ContentSection.bs.js";
import Modal from "@mui/material/Modal";
import Tooltip from "@mui/material/Tooltip";
import InfoOutlined from "@mui/icons-material/InfoOutlined";

function InfoTooltip(Props) {
  var children = Props.children;
  var match = React.useState(function () {
        return false;
      });
  var setModalOpen = match[1];
  return React.createElement(React.Fragment, undefined, React.createElement(Tooltip, {
                  title: children,
                  children: React.createElement("div", {
                        className: "cursor-pointer",
                        onClick: (function (param) {
                            return Curry._1(setModalOpen, (function (param) {
                                          return true;
                                        }));
                          })
                      }, React.createElement(InfoOutlined, {
                            fontSize: "small"
                          }))
                }), React.createElement(Modal, {
                  open: match[0],
                  onClose: (function (param) {
                      return Curry._1(setModalOpen, (function (param) {
                                    return false;
                                  }));
                    }),
                  children: React.createElement("div", {
                        className: CssJs.style([
                              CssJs.outline(CssJs.px(0), CssJs.solid, CssJs.transparent),
                              CssJs.position(CssJs.absolute),
                              CssJs.width(CssJs.fitContent),
                              CssJs.left(CssJs.pct(50)),
                              CssJs.top(CssJs.pct(50)),
                              CssJs.transform(CssJs.translate(CssJs.pct(-50), CssJs.pct(-50))),
                              CssJs.maxWidth(CssJs.px(320)),
                              CssJs.height(CssJs.auto)
                            ])
                      }, React.createElement(ContentSection.make, {
                            level: 0,
                            children: children
                          }))
                }));
}

var make = InfoTooltip;

export {
  make ,
  
}
/* CssJs Not a pure module */
